const Format = {
    Number(data) {
        if (!data)
            return 0;

        let br = Intl.NumberFormat('pt-BR');

        return br.format(data);
    }
};

export default Format;
